import type { SortEntry } from "./sort-types";

export function sortItems<T>(items: T[], sorts: SortEntry[], statusOrder?: Record<string, number>): T[] {
  if (sorts.length === 0) return items;

  return [...items].sort((a, b) => {
    for (const { column, direction } of sorts) {
      let cmp: number;

      if (column === "status" && statusOrder) {
        const aOrder = statusOrder[(a as Record<string, unknown>)[column] as string] ?? 99;
        const bOrder = statusOrder[(b as Record<string, unknown>)[column] as string] ?? 99;
        cmp = aOrder - bOrder;
      } else {
        const aVal = (a as Record<string, unknown>)[column];
        const bVal = (b as Record<string, unknown>)[column];

        if (aVal == null && bVal == null) {
          cmp = 0;
        } else if (aVal == null) {
          cmp = 1;
        } else if (bVal == null) {
          cmp = -1;
        } else {
          cmp = String(aVal).localeCompare(String(bVal));
        }
      }

      if (cmp !== 0) return direction === "asc" ? cmp : -cmp;
    }
    return 0;
  });
}
